module.exports = __webpack_public_path__ + "media/images/pc/maedori_photowedding/banner_family-21a65a73678d9e1484e646661a527fb5.webp";